// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"1ae0e128","656":"b8d4a83c","756":"b897c683","831":"8ee5591f","968":"9a99d66c"}[chunkId] + ".chunk.js";
};